import { sanctionedCountriesState } from 'api/configurations/getSanctionedCountries';
import { useMemo } from 'react';
import { useRecoilValueLoadable } from 'recoil';
import checkLoadable from 'utils/recoil/checkLoadable';
export default function useSanctionedCountryCodes() {
  const loadable = useRecoilValueLoadable(sanctionedCountriesState);
  const {
    contents,
    loading,
    error
  } = checkLoadable(loadable);
  const sanctionedCodes = useMemo(() => {
    const list = contents?.results ?? [];
    return new Set(list.map(c => String(c.isoCode)));
  }, [contents]);
  return {
    sanctionedCodes,
    loading,
    error: Boolean(error)
  };
}